var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "entity-header-v2",
    {
      attrs: { icon: _vm.icon, details: _vm.details },
      scopedSlots: _vm._u(
        [
          {
            key: "icon",
            fn: function () {
              return [_vm._t("icon")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [_vm._v(" "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }